import {
  Box,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getCheckinPercentage } from '../../stores/slices/dashboard/dashboardActions';
import Card from '../Card';

const Checkins = () => {
  const { checkinPercent, checkinLoading } = useSelector(
    state => state.dashboard
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCheckinPercentage());
    // eslint-disable-next-line
  }, []);
  return (
    <Box>
      <Card maxW={{ base: 'full', md: '150px' }}>
        <Text fontWeight={'bold'} fontSize="md" w="full">
          Check-Ins
        </Text>
        <CircularProgress
          mt={'2'}
          size="100px"
          value={
            checkinLoading || !checkinPercent
              ? 0
              : checkinPercent?.checkin_percentage.toFixed(2)
          }
          color="primary"
          trackColor="red.400"
        >
          <CircularProgressLabel>
            <Flex justify={'center'}>
              <Text fontWeight={'bold'} w="80%">
                {checkinLoading || !checkinPercent
                  ? 0
                  : checkinPercent?.checkin_percentage.toFixed(2)}
                % Complete
              </Text>
            </Flex>
          </CircularProgressLabel>
        </CircularProgress>
      </Card>
    </Box>
  );
};

export default Checkins;
